
import React, { useEffect, useRef } from "react";
import { Container, Placeholder } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import uniqid from 'uniqid';

import ScrollButtons from "./ScrollButtons";
import CategoryLinkIconRight from "./CategoryLinkIconRight";
import CategoryTitle from "./CategoryTitle";
import CategoryLinkImageGradient from "./CategoryLinkImageGradient";

import slots from '../data/icons/slots.svg';
import fruits from '../data/icons/fruits.svg';
import diamonds from '../data/icons/diamonds.svg';
import gold from '../data/icons/gold.svg';
import egypt from '../data/icons/egypt.svg';
import fortune from '../data/icons/fortune.svg';
import empires from '../data/icons/empires.svg';
import vikings from '../data/icons/vikings.svg';
import wildlife from '../data/icons/wildlife.svg';
import joker from '../data/icons/joker.svg';
import latin from '../data/icons/latin.svg';
import music from '../data/icons/music.svg';
import safari from '../data/icons/safari.svg';
import book from '../data/icons/book.svg';
import vegas from '../data/icons/vegas.svg';
import hollywood from '../data/icons/hollywood.svg';
import irish from '../data/icons/irish.svg';
import sports from '../data/icons/sports.svg';
import treasure from '../data/icons/treasure.svg';
import sweets from '../data/icons/sweets.svg';
import vampires from '../data/icons/vampires.svg';
import wild_west from '../data/icons/wild-west.svg';
import dragon from '../data/icons/dragon.svg';
import jurassic from '../data/icons/jurassic.svg';
import beautiful_asia from '../data/icons/beautiful-asia.svg';
import high_seas from '../data/icons/high-seas.svg';
import femme_fatale from '../data/icons/femme-fatale.svg';
import mystery from '../data/icons/mystery.svg';
import sci_fi from '../data/icons/sci-fi.svg';
import wonderland from '../data/icons/wonderland.svg';
import gangster from '../data/icons/gangster.svg';
import fantasy from '../data/icons/fantasy.svg';
import heist from '../data/icons/heist.svg';
import filthy_rich from '../data/icons/filthy-rich.svg';
import crash from '../data/icons/crash.svg';
import betting from '../data/icons/betting.svg';

import './tagsRowSquares.scss';


export default function TagsRowSquares({ categoryURL }) {
    const country = useSelector((state) => state.globalContent.data.country)
    const categories = useSelector((state) => state.gameCategories.list);
    const category = categories ? (categories[`${categoryURL}-${country.ISOcode}`] || categories[categoryURL]) : null;

    const container = useRef(null);
    const placeholder = new Array(20).fill(null);

    return (
        <Container fluid="lg" className="game-row-container section-margin" >

            {/* Title */}
            {/* {
                category ? <h3 className="h3 mb-3">Pick your theme</h3> :
                    <Placeholder as="h3" animation="glow" className="mb-3">
                        <Placeholder xs={12} style={{ width: "170px", borderRadius: "10px" }} />
                    </Placeholder>
            } */}
            <CategoryTitle title={'Pick your theme'} />

            {/* Row */}
            <div className="position-relative">
                <div className="tags-row-squares-wrapper" ref={container}>

                    {/* Games */}
                    {
                        !category ? placeholder.map((tag) => <TagSquare tag={tag} key={uniqid()} />) :
                            category.tags.map(item => {
                                return <TagSquare tag={item.tag} key={uniqid()} />
                            })
                    }
                </div>

                {/* Scroll */}
                <ScrollButtons container={container} />
            </div>
        </Container>
    );
}

function TagSquare({ tag }) {
    const locale = useSelector((state) => state.globalContent.data.locale);
    const table = {
        'All slots': 'https://cherryspins.b-cdn.net/themes/theme_slots.jpg',
        'Fruits': 'https://cherryspins.b-cdn.net/themes/theme_fruits.jpg',
        'Diamonds': 'https://cherryspins.b-cdn.net/themes/theme_diamonds.jpg',
        'Gold': 'https://cherryspins.b-cdn.net/themes/theme_gold.jpg',
        'Egypt': 'https://cherryspins.b-cdn.net/themes/theme_egypt.jpg',
        'Fortune': 'https://cherryspins.b-cdn.net/themes/theme_fortune.jpg',
        'Empires': 'https://cherryspins.b-cdn.net/themes/theme_empire.jpg',
        'Vikings': 'https://cherryspins.b-cdn.net/themes/theme_vikings.jpg',
        'Wildlife': 'https://cherryspins.b-cdn.net/themes/theme_wildlife.jpg',
        'Joker': 'https://cherryspins.b-cdn.net/themes/theme_joker.jpg',
        'Latin': 'https://cherryspins.b-cdn.net/themes/theme_latin.jpg',
        'Music and bands': 'https://cherryspins.b-cdn.net/themes/theme_music.jpg',
        'Safari': 'https://cherryspins.b-cdn.net/themes/theme_safari.jpg',
        'Book': 'https://cherryspins.b-cdn.net/themes/theme_book.jpg',
        'Vegas': 'https://cherryspins.b-cdn.net/themes/theme_vegas.jpg',
        'Hollywood': 'https://cherryspins.b-cdn.net/themes/theme_hollywood.jpg',
        'Irish': 'https://cherryspins.b-cdn.net/themes/theme_irish.jpg',
        'Sports': 'https://cherryspins.b-cdn.net/themes/theme_sports.jpg',
        'Treasure': 'https://cherryspins.b-cdn.net/themes/theme_treasure.jpg',
        'Sweets': 'https://cherryspins.b-cdn.net/themes/theme_candy.jpg',
        'Vampires': 'https://cherryspins.b-cdn.net/themes/theme_vampires.jpg',
        'Wild West': 'https://cherryspins.b-cdn.net/themes/theme_wild-west.jpg',
        'Dragon': 'https://cherryspins.b-cdn.net/themes/theme_dragon.jpg',
        'Jurassic': 'https://cherryspins.b-cdn.net/themes/theme_jurassic.jpg',
        'Beautiful Asia': 'https://cherryspins.b-cdn.net/themes/theme_beautiful_asia.jpg',
        'High seas': 'https://cherryspins.b-cdn.net/themes/theme_high_seas.jpg',
        'Femme fatale': 'https://cherryspins.b-cdn.net/themes/theme_femme_fatale.jpg',
        'Mystery': 'https://cherryspins.b-cdn.net/themes/theme_mystery.jpg',
        'Sci-Fi': 'https://cherryspins.b-cdn.net/themes/theme_sci-fi.jpg',
        'Wonderland': 'https://cherryspins.b-cdn.net/themes/theme_wonderland.jpg',
        'Gangster': 'https://cherryspins.b-cdn.net/themes/theme_gangster.jpg',
        'Fantasy': 'https://cherryspins.b-cdn.net/themes/theme_fantasy.jpg',
        'Heist': 'https://cherryspins.b-cdn.net/themes/theme_heist.jpg',
        'Filthy rich': 'https://cherryspins.b-cdn.net/themes/theme_filthy_rich.jpg',
        'Crash': 'https://cherryspins.b-cdn.net/themes/theme_crash.jpg',
        'Betting': 'https://cherryspins.b-cdn.net/themes/theme_betting.jpg'
    }

    useEffect(() => { })

    if (!tag) {
        return (
            <Placeholder as="div" animation="glow">
                <Placeholder xs={12} className="tags-row-square-placeholder" />
            </Placeholder>
        )
    }

    return (
        <CategoryLinkImageGradient to={`/${locale}/games/all-slots/${encodeURI(tag)}`} title={tag} src={table[tag]} alt='' />
    )
}